<template>
    <div class="product-card">
        <v-toolbar color="white" flat app light tabs>
            <v-btn icon small flat :to="$route.query.buyer ? '/?buyer=1' : '/'">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>

            <v-toolbar-title class="subheading">My Purchase</v-toolbar-title>

            <template v-slot:extension>
                <v-tabs v-model="tab" color="white" grow>
                    <v-tabs-slider color="orange"></v-tabs-slider>
                    <v-tab class="text-capitalize" ripple>To Pay</v-tab>
                    <v-tab class="text-capitalize" ripple>Processing</v-tab>
                    <v-tab class="text-capitalize" ripple>Shipping</v-tab>
                    <v-tab class="text-capitalize" ripple>Completed</v-tab>
                    <v-tab class="text-capitalize" ripple>Cancelled</v-tab>
                    <v-tab class="text-capitalize" ripple>For Pick Up</v-tab>
                </v-tabs>
            </template>
        </v-toolbar>

        <v-tabs-items v-model="tab">
            <v-tab-item>
                <purchase-pending :order-data="pending" @cancelOrder="cancelOrder" @viewDetail="viewDetail" @payNow="payNow" />
            </v-tab-item>
            <v-tab-item>
                <purchase-processing :order-data="processing" @viewDetail="viewDetail" />
            </v-tab-item>
            <v-tab-item>
                <purchase-receiving :order-data="receiving" @viewDetail="viewDetail" @receivedOrder="receivedOrder" @disputeOrder="disputeOrder" />
            </v-tab-item>
            <v-tab-item>
                <purchase-completed :order-data="completed" @viewDetail="viewDetail" />
            </v-tab-item>
            <v-tab-item>
                <purchase-cancelled :order-data="cancelled" @viewDetail="viewDetail" />
            </v-tab-item>
            <v-tab-item>
                <purchase-pickup :order-data="pickUp" @viewDetail="viewDetail" />
            </v-tab-item>
        </v-tabs-items>

        <!-- <bottom-nav></bottom-nav> -->
        <purchase-details :dialog="purchaseDialog" @hide="purchaseDialog = false" :form-data="detailData" @goToLogistic="goToLogistic"></purchase-details>
        <loader v-if="loading"></loader>
        <choose-payment-method :cod-avail="codAvail" :show="dialog_payment_method" @hide="dialog_payment_method = false" event-name="savePaymentMethod:mypurchase"></choose-payment-method>
        <purchase-tracking :tracking-number="trackingNumber" :dialog="dialogLogistic" @hide="dialogLogistic = false"></purchase-tracking>
    </div>
</template>

<script>
    import Loader from "../../components/Loader";
    import PurchaseDetails from "./PurchaseDetails";
    import PurchasePending from "./PurchasePending";
    import PurchaseProcessing from "./PurchaseProcessing";
    import PurchaseReceiving from "./PurchaseReceiving";
    import PurchaseCompleted from "./PurchaseCompleted";
    import PurchaseCancelled from "./PurchaseCancelled";
    import PurchasePickup from "./PurchasePickup";
    import PurchaseTracking from "./PurchaseTracking";
    export default {
        name: 'MyPurchase',
        components: {
            PurchaseTracking,
            PurchasePickup,
            PurchaseCancelled,
            PurchaseCompleted,
            PurchaseReceiving,
            PurchaseProcessing,
            PurchasePending,
            Loader,
            PurchaseDetails
        },
        watch :{
            tab : {
                handler(newVal){

                    this.getData();

                },
            }
        },
        data() {
            return {
                active: null,
                pending: [],
                processing: [],
                receiving: [],
                completed: [],
                cancelled: [],
                pickUp: [],
                purchaseDialog: false,
                loading: false,
                detailData: {},
                dialog_payment_method: false,
                payment_method: null,
                order: null,
                initStatus: false,
                codAvail : true,
                tab: null,
                dialogLogistic : false,
                trackingNumber : '',
            }
        },
        methods: {
            getData() {
                let statusDisplay = '';
                switch (this.tab) {
                    case 0:
                        statusDisplay = 'pending';
                        break;
                    case 1:
                        statusDisplay = 'processing';
                        break;
                    case 2:
                        statusDisplay = 'shipping';
                        break;
                    case 3:
                        statusDisplay = 'completed';
                        break;
                    case 4:
                        statusDisplay = 'cancelled';
                        break;
                    case 5:
                        statusDisplay = 'pick_up';
                        break;
                }

                this.loading = true;
                axios.get(`/api/order?myPurchase=1&showAll=1&filterStatus=${statusDisplay}`)
                    .then(res => {
                        this.designate(res.data.data);
                        this.loading = false;
                    })
                    .catch(err => {
                        this.toaster('something went wrong.', 201);
                    });
            },
            cancelOrder(data){
                this.loading = true;
                axios.post(`/api/buyer/cancel_order/${data.id}`)
                    .then(res => {
                        this.getData();
                    })
                    .catch(err => {
                        this.toaster(err.response.data.message, 201);
                        this.loading = false;
                    });
            },
            designate(datas) {
                this.pending = [];
                this.shipping = [];
                this.receiving = [];
                this.completed = [];
                this.cancelled = [];
                this.pickUp = [];
                this.processing = [];
                datas.forEach((data, index) => {
                    switch (data.status.toLowerCase()) {
                        case 'pending':
                            this.pending.push(data);
                            break;
                        case 'processing':
                            this.processing.push(data);
                            break;
                        case 'shipping':
                            this.receiving.push(data);
                            break;
                        case 'completed':
                            this.completed.push(data);
                            break;
                        case 'cancelled':
                            this.cancelled.push(data);
                            break;
                        case 'pick_up':
                            this.pickUp.push(data);
                            break;
                    }
                });
                // console.log(this.pending, 'pending', this.processing, 'processing', this.receiving, 'receiving', this.completed, 'completed', this.cancelled, 'cancelled', this.pickUp, 'pickUp')
            },
            orderPay() {
                let formData = {};
                formData.order_id = this.order.id;
                formData.payment = this.payment_method;
                this.loading = true;
                axios.put(`/api/order/${this.order.id}`, formData)
                    .then(res => {
                        this.getData();
                        let paymentRedirect = ['paymaya', 'bayd', 'bitc', 'cc', 'cebl', 'cup', 'dpay', 'ecpy',
                            'gcsh', 'lbc', 'pypl', 'mlh', 'rds', 'smr', 'bol', '711'
                        ];
                        if (paymentRedirect.indexOf(this.payment_method.name.toLowerCase()) > -1) {
                            window.location.href = res.data;
                        }
                    })
                    .catch(res => {
                        this.toaster('something went wrong', 201);
                    });
            },
            viewDetail(data) {
                this.purchaseDialog = true;
                this.detailData = data;
            },
            payNow(data) {
                this.dialog_payment_method = true;
                this.order = data;
                this.checkCODAvail();
            },
            checkCODAvail(){
                if (this.order.courier.name.toLowerCase() == 'quadx'){
                    this.codAvail = true;
                }
                else{
                    this.codAvail = false;
                }
            },
            onSavePaymentMethod() {
                EventBus.$off('savePaymentMethod:mypurchase');
                EventBus.$on('savePaymentMethod:mypurchase', (res) => {
                    this.dialog_payment_method  = false;
                    this.payment_method         = res;
                    this.orderPay();
                });
            },
            receivedOrder(data) {
                this.loading = true;
                let formData = {};
                axios.post('/api/order/receive_order/' + data.id, formData)
                    .then(res => {
                        this.getData();
                        this.toaster('order receive.', 200)
                    })
                    .catch(err => {
                        this.toaster('something went wrong.', 201);
                    });
            },
            disputeOrder(data) {
                const sender_id = this.$store.state.user.id;
                const receiver_id = data.shop.user_id;

                if (sender_id === receiver_id){
                    this.toaster('This product is yours.', 201);
                    return;
                }

                const formData          = {};
                formData.sender_id      = sender_id;
                formData.receiver_id    = receiver_id;
                formData.dispute        = data.id;
                formData.name           = data.shop.name;

                this.loading = true;
                axios.post('api/thread', formData)
                .then(res=>{
                    this.$router.push({
                        path: `/message/content/${res.data}/${sender_id}/${receiver_id}`,
                    });
                })
                .catch(err=>{
                    this.toaster('something went wrong', 201)
                })
                .finally(()=>{
                    this.loading = false;
                });
            },
            countOrderItemQuantity(data) {
                let count = 0;
                data.order_items.map((item, index) => {
                    count += item.quantity;
                });
                return count;
            },
            onCloseMethod() {
                EventBus.$off('choosePaymentMethodDialog');
                EventBus.$on('choosePaymentMethodDialog', (res) => {
                    this.dialog_payment_method = res;
                });
            },
            goToLogistic(tracking_number){
                this.trackingNumber = tracking_number;
                this.dialogLogistic = true;
            }
        },
        mounted() {
            this.onSavePaymentMethod();
            this.onCloseMethod();
            if (!this.initStatus) {
                let status = this.$route.query.status;
                this.tab = parseInt(status);
                this.initStatus = true;
            }
        },
        destroyed() {
            EventBus.$off('savePaymentMethod:mypurchase');
        }
    }
</script>

<style lang="scss" scoped>

</style>
